import { render } from "./tender_payment.vue?vue&type=template&id=66d1d681"
import script from "./tender_payment.vue?vue&type=script&lang=js"
export * from "./tender_payment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/tender/tabs/tender_payment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66d1d681"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66d1d681', __exports__)) {
    console.log('reload')
    api.reload('66d1d681', __exports__)
  }
  
  module.hot.accept("./tender_payment.vue?vue&type=template&id=66d1d681", () => {
    console.log('re-render')
    api.rerender('66d1d681', render)
  })

}


export default __exports__